module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1295.d665432d.png";